import { useDataBoxEvents } from '@gov-nx/core/events';
import {
	useDataBoxCredit,
	useDataBoxLoader,
	useDataBoxUnreadMessages,
} from '@gov-nx/module/data-box';
import { useMyFilesStorage } from '@gov-nx/module/page';

export const DataBoxListener = () => {
	const { refetchDataBoxes } = useDataBoxLoader();
	const myfilesStorage = useMyFilesStorage();
	const { refetch: refetchCredit } = useDataBoxCredit();
	const { refetchDataBoxUnreadMessages } = useDataBoxUnreadMessages();

	useDataBoxEvents({
		onCreditsRefetch: () => {
			refetchCredit();
		},
		onStorageRefetch: () => {
			myfilesStorage.refetch();
		},
		onUnreadMessagesCountsRefetch: async (_, { callback }) => {
			await refetchDataBoxUnreadMessages();
			callback && callback();
		},
		onRefreshList: async (_, { callback }) => {
			await refetchDataBoxes();
			callback && callback();
		},
	});

	return null;
};
